import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import {
  Projekt,
  ProjektDetail,
  ProjektRequest,
  ProjektZugriffBenutzer
} from '../Models/projekt.model';
import { ProjektListen } from '../Models/Sps';
import { Anlagenteil } from '../Models/messstelle.model';

/** Projektstammdaten (Projektname, Projektnummer, Kunde, Anlage). */
@Injectable({ providedIn: 'root' })
export class ProjektService {
  private apiUrl = environment.apiBaseUrl + '/projekt';

  constructor(private http: HttpClient) { }

  /** Übersicht aller sichtbaren Projekte inklusive Status-Kennzahlen. */
  getProjekte(): Observable<Projekt[]> {
    return this.http.get<Projekt[]>(this.apiUrl);
  }

  /** Detail inklusive der Inbetriebnahmen des Projekts. */
  getProjekt(id: number): Observable<ProjektDetail> {
    return this.http.get<ProjektDetail>(`${this.apiUrl}/${id}`);
  }

  /**
   * Alle Listen eines Projekts, gruppiert: Messstellen-/Verbraucherlisten
   * (bestehend) und SPS-Listen samt gemeinsamem SPS-Fortschritt.
   * Backend: GET api/projekt/{id}/listen
   */
  getProjektListen(id: number): Observable<ProjektListen> {
    return this.http.get<ProjektListen>(`${this.apiUrl}/${id}/listen`);
  }

  /**
   * Alle Anlagenteile des Projekts – alphabetisch, ausschließlich dieses
   * Projekts. Gemeinsame Quelle für die Anlagenteil-Filter der SPS-Listen und
   * der SPS-Prüfung. Backend: GET api/projekt/{id}/anlagenteile
   */
  getAnlagenteile(id: number): Observable<Anlagenteil[]> {
    return this.http.get<Anlagenteil[]>(`${this.apiUrl}/${id}/anlagenteile`);
  }

  createProjekt(request: ProjektRequest): Observable<ProjektDetail> {
    return this.http.post<ProjektDetail>(this.apiUrl, request);
  }

  updateProjekt(id: number, request: ProjektRequest): Observable<ProjektDetail> {
    return this.http.put<ProjektDetail>(`${this.apiUrl}/${id}`, request);
  }

  deleteProjekt(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  getZugriffsBenutzer(): Observable<ProjektZugriffBenutzer[]> {
    return this.http.get<ProjektZugriffBenutzer[]>(
      `${this.apiUrl}/zugriffsbenutzer`
    );
  }

  getProjektZugriffe(
    projektId: number
  ): Observable<string[]> {

    return this.http.get<string[]>(
      `${this.apiUrl}/${projektId}/zugriffe`
    );
  }


  setProjektZugriffe(
    projektId: number,
    userIds: string[]
  ): Observable<void> {

    return this.http.put<void>(
      `${this.apiUrl}/${projektId}/zugriffe`,
      {
        userIds
      }
    );
  }
}
